import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgInformation = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#04C"
        fillRule="evenodd"
        d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zM7 4.503a1.013 1.013 0 01.288-.711A.985.985 0 018 3.5a.992.992 0 011 1.003 1.006 1.006 0 01-.288.712.96.96 0 01-.32.21C8.27 5.475 8.14 5.5 8 5.5a1.02 1.02 0 01-.396-.075.968.968 0 01-.527-.527A1.006 1.006 0 017 4.503zm.25 2.747a.75.75 0 011.5 0v4.5a.75.75 0 01-1.5 0v-4.5z"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgInformation.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgInformation;
